import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;
`;

const FilterContainer = styled.div`
  border-right: 1px solid #ccd0e3;
  width: 20%;
  min-height: calc(100vh - 124px);
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  padding: 16px 33px;
`;

const ResultsContainer = styled.div`
  width: 80%;
`;

const Product = styled.div`
  display: flex;
`;

const StyledSelectProduct = {
  Container,
  FilterContainer,
  ResultsContainer,
  Product,
};

export default StyledSelectProduct;
